<template>
  <div class="app-container">
    <BjRouteTabs :route-list="LOGISTICS_COMPANY_ROUTE_LIST" />
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('businessLogisticsCompanyBusiness.table.abbreviation')" prop="name">
            <BjInput v-model="queryParams.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('businessLogisticsCompanyBusiness.table.abbreviation')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('businessLogisticsCompany.table.logisticsCompanyName2')" prop="companyId">
            <BjSelectLogisticCompany v-model="queryParams.companyId" :placeholder="$t('businessLogisticsCompany.table.logisticsCompanyName2')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('QuotationCenter.zone')" prop="customerLogisticsGroupDictId">
            <BjSelectLov v-model="queryParams.customerLogisticsGroupDictId" :placeholder="$t('QuotationCenter.zone')" :option-list="zoneGroupList" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="'API ' +$t('businessLogisticsCompany.common.status')" prop="enableFlag">
            <BjSelectLov v-model="queryParams.enableFlag" :placeholder="'API ' +$t('businessLogisticsCompany.common.status')" :option-list="STATUS_ENABLED_TRUE" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="'CSG ' +$t('businessLogisticsCompany.common.status')" prop="csgEnableFlag">
            <BjSelectLov v-model="queryParams.csgEnableFlag" :placeholder="'CSG ' +$t('businessLogisticsCompany.common.status')" :option-list="STATUS_ENABLED_TRUE" />
          </el-form-item>
        </el-col>
      </template>
      <template v-if="!$store.getters.cusId" v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('businessLogisticsCompany.common.add') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'customerLogisticsGroupDictId'">{{ zoneGroupList.bjGet(scope.row.customerLogisticsGroupDictId) }}</span>
              <el-tag v-else-if="col.prop === 'enableFlag'" :type="scope.row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row[col.prop])) }}</el-tag>
              <el-tag v-else-if="col.prop === 'csgEnableFlag'" :type="scope.row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row[col.prop])) }}</el-tag>
              <span v-else-if="col.prop === 'profitMargin'">{{ scope.row.profitMargin }}%</span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction' && !$store.getters.cusId" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="{ row }">
              <el-dropdown v-hasDropdownChildren @command="command($event, row)">
                <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="!row.enableFlag" command="apiOpen">API {{ $t('enableText') }} </el-dropdown-item>
                  <el-dropdown-item v-if="row.enableFlag" command="apiClose">API {{ $t('disableText') }} </el-dropdown-item>
                  <el-dropdown-item v-if="!row.csgEnableFlag" command="csgOpen">CSG {{ $t('enableText') }} </el-dropdown-item>
                  <el-dropdown-item v-if="row.csgEnableFlag" command="csgClose">CSG {{ $t('disableText') }} </el-dropdown-item>
                  <el-dropdown-item command="Setting"> {{ $t('settingText1') }} </el-dropdown-item>
                  <el-dropdown-item command="showLog">{{ $t('logText') }} </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <!-- <el-button v-if="!scope.row.enableFlag" type="text" @click="onStatus(true, scope.row)">{{ $t('enableText') }}</el-button>
              <el-button v-else type="text" @click="onStatus(false, scope.row)">{{ $t('disableText') }}</el-button>
              <el-button type="text" @click="showLog(scope.row)">{{ $t('logText')}}</el-button> -->
              <!-- <el-button type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button> -->
              <!-- <el-button :disabled="scope.row.status == 1" type="text" class="delete-btn" @click="onDelete(scope.row)">{{ $t('delText') }}</el-button> -->
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { logisticApi, channelApi, settingApi } from '@/api';
import orderLog from '@/utils/log.js';
import { LOGISTICS_COMPANY_ROUTE_LIST, STATUS_ENABLED_TRUE } from '@/utils/constants';
import DataForm from './components/DataForm.vue';
export default {
  name: 'BusinessLogisticsCompanyBusinessIndexCSGAdmin',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      LOGISTICS_COMPANY_ROUTE_LIST,
      STATUS_ENABLED_TRUE,
      queryApi: logisticApi.getLogisticsBusiness,
      // 查询参数
      queryParams: {
        name: null,
        companyId: null,
        customerLogisticsGroupDictId: null,
        enableFlag: null,
        csgEnableFlag: null,
      },
      labelsVersion: 11,
      labelList1: [
        { label: this.$t('businessLogisticsCompanyBusiness.table.abbreviation'), prop: 'name', isCheck: true, disabled: false },
        { label: this.$t('businessLogisticsCompanyBusiness.table.full'), prop: 'logisticsName', isCheck: true, disabled: false },
        { label: this.$t('businessLogisticsCompany.table.logisticsCompanyName2'), prop: 'companyName', isCheck: true, disabled: false },
        { label: this.$t('QuotationCenter.zone'), prop: 'customerLogisticsGroupDictId', isCheck: true, disabled: false },
        // { label: this.$t('businessLogisticsCompanyBusiness.table.DefaultMarkup'), prop: 'rate', isCheck: true, disabled: false },
        { label: this.$t('businessLogisticsCompanyBusiness.table.ProfitMargin'), prop: 'profitMargin', isCheck: true, disabled: false },
        { label: 'API ' + this.$t('businessLogisticsCompany.table.status'), prop: 'enableFlag', isCheck: true, disabled: false },
        { label: 'CSG ' + this.$t('businessLogisticsCompany.table.status'), prop: 'csgEnableFlag', isCheck: true, disabled: false },
        { label: this.$t('businessLogisticsCompany.table.creator'), prop: 'createdName', isCheck: true, disabled: false },
        { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false, width: 200 },
        { label: this.$t('businessLogisticsCompany.table.action'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 100},
      ],
    };
  },
  computed: {
    labelList() {
      return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'profitMargin') : this.labelList1;
    },
  },
  watch: {},
  mounted() {
    // 获取分区列表（查询条件用）
    logisticApi.getLogisticGroupList({}).then(res => {
      if (!res.failed) {
        this.zoneGroupList = (res.content || []).map(item => ({
          label: item.logisticsGroupName,
          value: item.id
        }));
      }
    });
  },
  methods: {
    showLog(row) {
      orderLog(
        this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
          actionApi: settingApi.logisticsLogList,
          defaultQuery: {
            recordId: row.id,
            recordType: 'LOGISTICS SERVICE',
          },
          columns: [
            {
              prop: 'createdName',
              label: 'BjDialogListConfig.Operator',
            },
            {
              prop: 'creationDate',
              label: 'BjDialogListConfig.Operationtime',
            },
            {
              prop: 'remark',
              label: 'BjDialogListConfig.Remarks',
            },
          ],
        }),
      );
    },
    command(text, row) {
      switch (text) {
        case 'apiOpen': this.onStatus(true, row, 'api');
            break;
        case 'apiClose': this.onStatus(false, row, 'api');
            break;
        case 'csgOpen': this.onStatus(true, row, 'csg');
            break;
        case 'csgClose': this.onStatus(false, row, 'csg');
            break;
        //  跳转BusinessLogisticsCompanyBusinessSetting
        case 'Setting': this.$router.push({
          name: 'BusinessLogisticsCompanyBusinessSetting',
          query: { id: row.id },
        });
            break;
        case 'showLog': this.showLog(row);
            break;
      }
    },
    /** 修改状态 */
    onStatus(flag, row, type) {
      const TEXT = this.$t(STATUS_ENABLED_TRUE.bjGet(flag));
      this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        const data = type == 'api' ? { id: row.id, enableFlag: flag, objectVersionNumber: row.objectVersionNumber } : { id: row.id, csgEnableFlag: flag, objectVersionNumber: row.objectVersionNumber };
        this.operationApi(data, {
          logisticsCode: row.code,
          logisticsStatus: flag
        }, type);
      });
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreDelTipText')} ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        this.batchDeleteApi({ ids: [row.id] });
      });
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        this.batchDeleteApi({ ids: ids });
      });
    },
    /** 新建 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      console.log(row);
      this.$refs.DataForm.show(this.$lodash.clone(row));
    },

    operationApi(API_DATA, API_DATA2, type) {
      const apiName = type == 'api' ? 'updateLogisticsBusiness' : 'updateCsgEnableFlag';
      logisticApi[apiName](API_DATA).then(res => {
        if (!res.failed) {
          channelApi.updateByLogisticsCodeLogisticsStatus(API_DATA2).then(res2 => {
            if (!res2.failed) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
              }
          });
        }
      });
    },
    batchDeleteApi(API_DATA) {
      logisticApi.deleteLogisticsBusiness(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>
